<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <!-- <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">

                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img src="/img/theme/team-4-800x800.jpg" class="rounded-circle">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                            <div class="d-flex justify-content-between">
                                <base-button size="sm" type="info" class="mr-4">Connect</base-button>
                                <base-button size="sm" type="default" class="float-right">Message</base-button>
                            </div>
                        </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                                        <div>
                                            <span class="heading">22</span>
                                            <span class="description">Friends</span>
                                        </div>
                                        <div>
                                            <span class="heading">10</span>
                                            <span class="description">Photos</span>
                                        </div>
                                        <div>
                                            <span class="heading">89</span>
                                            <span class="description">Comments</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <h3>
                                    Jessica Jones<span class="font-weight-light">, 27</span>
                                </h3>
                                <div class="h5 font-weight-300">
                                    <i class="ni location_pin mr-2"></i>Bucharest, Romania
                                </div>
                                <div class="h5 mt-4">
                                    <i class="ni business_briefcase-24 mr-2"></i>Solution Manager - Creative Tim Officer
                                </div>
                                <div>
                                    <i class="ni education_hat mr-2"></i>University of Computer Science
                                </div>
                                <hr class="my-4" />
                                <p>Ryan — the name taken by Melbourne-raised, Brooklyn-based Nick Murphy — writes, performs and records all of his own music.</p>
                                <a href="#">Show more</a>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">{{$t('add_member')}}</h3>
                                </div>
                                <div class="col-4 text-right">
                                    <!-- <a href="#!" class="btn btn-sm btn-primary">Settings</a> -->
                                </div>
                            </div>
                        </div>
                        <template>
                            <ValidationObserver v-slot="{ passes }">
                            <form @submit.prevent="passes(onSubmit)">
                                <h6 class="heading-small text-muted mb-4">{{$t('user_information')}}</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input :name="$t('first_name')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('first_name')"
                                                        rules="required"
                                                        :placeholder="$t('first_name')"
                                                        v-model="form.firstname">
                                            </base-input>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input :name="$t('last_name')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('last_name')"
                                                        rules="required"
                                                        :placeholder="$t('last_name')"
                                                        v-model="form.lastname">
                                            </base-input>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input :name="$t('phone')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('phone')"
                                                        rules="required|min:9"
                                                        :placeholder="$t('phone')"
                                                        v-model="form.phone">
                                            </base-input>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input :name="$t('email')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('email')"
                                                        rules="required|email"
                                                        :placeholder="$t('email')"
                                                        v-model="form.email">
                                            </base-input>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input :name="$t('nickname')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('nickname')"
                                                        rules="required"
                                                        :placeholder="$t('nickname')"
                                                        v-model="form.nickname">
                                            </base-input>
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input :name="$t('id_card')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('id_card')"
                                                        rules="required"
                                                        :placeholder="$t('id_card')"
                                                        v-model="form.id_card">
                                            </base-input>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">

                                            {{$t('gender')}} <span style="color:red">*</span><br /><br />

                                            <base-radio name="male" class="mb-3" v-model="form.gender">
                                                {{$t('male')}}
                                            </base-radio>

                                            <base-radio name="female" class="mb-3" v-model="form.gender">
                                                {{$t('female')}}
                                            </base-radio>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">{{$t('contact_information')}}</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <base-input :name="$t('address')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('address')"
                                                        rules="required|min:4"
                                                        :placeholder="$t('address')"
                                                        v-model="form.address">
                                            </base-input>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <div class="text-right">
                                    <base-button nativeType="submit" type="primary" class="my-4">{{$t('add_member')}}</base-button>
                                </div>
                            </form>
                        </ValidationObserver>
                        </template>
                    </card>
                </div>
            </div>
        </div>
        <modal :show.sync="modal"
                :gradient="modal_setting.gradient"
                modal-classes="modal-danger modal-dialog-centered">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4"></h4>
                    <p>{{modal_setting.alert_text}}</p>
                </div>

                <template slot="footer">
                    <base-button type="link"
                                text-color="white"
                                class="ml-auto"
                                @click="modal = false">
                        {{$t('close')}}
                    </base-button>
                </template>
            </modal>
    </div>
</template>
<script>
import { ValidationObserver } from "vee-validate"
import i18n from "@/i18n"
  export default {
    name: 'addmember',
    components: {
        ValidationObserver
    },
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        form: {
          phone: '',
          email: '',
          firstname: '',
          lastname: '',
          nickname: '',
          id_card: '',
          address: '',
          gender: 'male'
        }
      }
    },
    methods: {
        modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        onSubmit () {
            this.$http.post('members', {
                "email": this.form.email,
                "phone": this.form.phone,
                "firstname": this.form.firstname,
                "lastname": this.form.lastname,
                "nickname": this.form.nickname,
                "id_card": this.form.id_card,
                "address": this.form.address,
                "gender": this.form.gender
            })
                .then(request => this.onSubmitSuccessful(request))
                .catch(() => this.onSubmitFailed())
        },
        onSubmitSuccessful (req) {
            if (req.data.code !== '0') {
                this.onSubmitFailed(req)
                return
            }
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/member')
        },
        onSubmitFailed (req) {
            this.modalAlert(req)
        },
    }
  };
</script>
<style></style>
